import { useDispatch, useSelector } from 'react-redux';
import { fetchJobDetails } from '../actions/confirm-job-action/job-details.action';
import { customerInfoActions } from '../reducers/customer-info.reducer';
import { CustomerInfoState, RootState } from '../types/store.types';

export const useCustomerInfoStore = () => {
  const customerInfoStore = useSelector<RootState, CustomerInfoState>((state) => state.customerInfo);
  const dispatch = useDispatch();
  const {
    updateUserInfo,
    updateMileInfo,
    updateMileToDestination,
    updateCrewNotes,
    addStop,
    removeAddStop,
    fetchCustomerInfoDetails,
    updateSlots,
  } = customerInfoActions;
  return {
    dispatch,
    updateUserInfo,
    updateMileInfo,
    updateMileToDestination,
    updateCrewNotes,
    customerInfoStore,
    addStop,
    removeAddStop,
    fetchJobDetails,
    fetchCustomerInfoDetails,
    updateSlots,
  };
};
